'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoadingButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _button = require('react-toolbox/lib/button');

var _spinner = require('./spinner');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

var LoadingButton = exports.LoadingButton = function (_Component) {
    _inherits(LoadingButton, _Component);

    function LoadingButton() {
        _classCallCheck(this, LoadingButton);

        var _this = _possibleConstructorReturn(this, (LoadingButton.__proto__ || Object.getPrototypeOf(LoadingButton)).apply(this, arguments));

        _this.state = {};
        _this.unmounted = false;
        return _this;
    }

    _createClass(LoadingButton, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.unmounted = true;
        }
    }, {
        key: 'setNotLoading',
        value: function setNotLoading() {
            if (!this.unmounted) {
                this.setState({ loading: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var internalLoading = this.state.loading;
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                onClick = _props.onClick,
                _props$loading = _props.loading,
                loading = _props$loading === undefined ? internalLoading : _props$loading;

            var buttonProps = Object.assign({}, this.props);
            delete buttonProps.loading;
            return React.createElement(_button.Button, __assign({}, buttonProps, { disabled: disabled || loading, onClick: onClick && function (e) {
                    var returnValue = onClick(e);
                    if (returnValue) {
                        _this2.setState({ loading: true });
                        returnValue.then(function () {
                            return _this2.setNotLoading();
                        }).catch(function (error) {
                            _this2.setNotLoading();
                            throw error;
                        });
                    }
                } }), children, loading && React.createElement(_spinner.Spinner, { size: 24, center: true, type: 'circular', background: 'rgba(255, 255, 255, 0.5)' }));
        }
    }]);

    return LoadingButton;
}(_react.Component);
//# sourceMappingURL=loading-button.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toolbox-components/dist/src/loading-button.js
 ** module id = 637
 ** module chunks = 0
 **/